// public/js/components/radio-group.js

const CLASSES = {
  // We don't apply specific 'valid' styles to the whole group (e.g. turning everything green),
  // we just let the CSS :checked state handle the "good" look (teal).
  valid: [], 
  
  // When invalid, we turn all options red to demand attention
  invalid: ['bg-red-50', 'border-red-600'],
  
  // Default state (relies on CSS for the checked teal state)
  neutral: ['bg-white', 'border-slate-600']
};

export default function RadioGroup(rootEl) {
  const inputs = Array.from(rootEl.querySelectorAll('input[type="radio"]'));
  const labels = Array.from(rootEl.querySelectorAll('label'));
  const errorDiv = rootEl.querySelector('[data-ref="error"]');
  
  // Check if the container has the data-required attribute we added in EJS
  const isRequired = rootEl.dataset.required === 'true';

  if (!inputs.length) return;

  const setVisualState = (state, message = '') => {
    requestAnimationFrame(() => {
      // 1. Toggle Error Message
      if (errorDiv) {
        errorDiv.textContent = message;
        if (message) errorDiv.classList.remove('hidden');
        else errorDiv.classList.add('hidden');
      }

      // 2. Toggle Classes on Labels
      labels.forEach((label) => {
        // Always remove all state classes first to clean up
        label.classList.remove(
          ...CLASSES.invalid,
          ...CLASSES.neutral,
          ...CLASSES.valid
        );

        switch (state) {
          case 'invalid':
            label.classList.add(...CLASSES.invalid);
            // We use a data attribute so CSS can potentially override hover states if needed
            label.setAttribute('data-invalid', 'true');
            break;
            
          default: // valid or neutral
            label.classList.add(...CLASSES.neutral);
            label.removeAttribute('data-invalid');
            break;
        }
      });

      // 3. Update ARIA Accessibility on Inputs
      inputs.forEach(input => {
        if (state === 'invalid') input.setAttribute('aria-invalid', 'true');
        else input.setAttribute('aria-invalid', 'false');
      });
    });
  };

  const validate = () => {
    // If not required, it's always valid
    if (!isRequired) {
      setVisualState('neutral');
      return true;
    }

    const isChecked = inputs.some((input) => input.checked);

    if (!isChecked) {
      setVisualState('invalid', 'Please select an option.');
      return false;
    }

    setVisualState('valid');
    return true;
  };

  // Expose validate method for main.js to call
  rootEl.validate = validate;

  // Clear errors immediately when user selects an option
  inputs.forEach((input) => {
    input.addEventListener('change', () => {
      setVisualState('valid');
    });
    
    // Also validate if the form triggers an invalid event (browser default)
    input.addEventListener('invalid', (e) => {
      e.preventDefault(); // Stop default browser bubble
      validate();
    });
  });
}